import { useState } from "react";

import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Menu, MenuItem, IconButton } from "@mui/material";
import ModalPuestos from "./ModalPuestos";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ModalEditarCandidatos from "./ModalEditarCandidatos";

export function CandidatosItem({
  applicant,
  index,
  puestosList,
  provincias,
  localidades,
  obtenerCandidatos,
  showToast,
}) {
  //const UrlApi = "http://localhost:27021/api"; //usoLocal
  const UrlApi = "https://empleosback.netizar.com/api"; //Ruta para produccion

  const [puestos, setPuestos] = useState(puestosList || []);
  const [idCandidato, setIdCandidato] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const fullName = `${applicant.nombre} ${applicant.apellido}`;
  const initials = `${applicant.nombre.charAt(0)}${applicant.apellido.charAt(
    0
  )}`.toUpperCase();

  const puestoTexto = (idPuesto) => {
    if (!idPuesto) return "Sin asignar"; // ✅ Mensaje claro si no tiene puesto

    const puestoDeTrabajo = puestos.find((puesto) => puesto.id === idPuesto);

    return puestoDeTrabajo?.puesto ?? "Sin asignar";
  };

  const truncateText = (text, maxLength = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const sobreMiText =
    applicant.sobre_mi || "El candidato no ingresó información";
  const shouldTruncate = sobreMiText.length > 100;
  const visibleText = isExpanded ? sobreMiText : truncateText(sobreMiText);

  const handleSeeCV = () => {
    if (applicant.path) {
      window.open(`${UrlApi}${applicant.path}`, "_blank");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [openModalPuestos, setOpenModalPuestos] = useState(false);
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function capitalizar(str) {
    if (!str || typeof str !== "string") return "";
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  const handleAsignarPuesto = (idCandidato) => {
    setIdCandidato(idCandidato);
    setOpenModalPuestos(true);
    handleClose();
  };

  const handleEditarCandidato = (idCandidato) => {
    setIdCandidato(idCandidato);
    setOpenModalEditar(true);
    handleClose();
  };

  return (
    <>
      <ModalPuestos
        onClose={() => {
          obtenerCandidatos(1, 12);
          setOpenModalPuestos(false);
        }}
        open={openModalPuestos}
        puestos={puestos}
        idCandidato={idCandidato}
        defaultValue={applicant.id_puesto}
        showToast={showToast}
      />
      <ModalEditarCandidatos
        onClose={() => {
          obtenerCandidatos(1, 12);
          setOpenModalEditar(false);
        }}
        open={openModalEditar}
        localidadesList={localidades}
        provinciasList={provincias}
        candidato={applicant}
        showToast={showToast}
      />

      <Box
        sx={{
          border: "2px solid black",
          boxShadow: 3,
          minHeight: "390px",

          p: 2,
          mb: 2,
          borderRadius: 1,
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "2px solid black",
            mb: 2,
            py: 1,
          }}
        >
          {/* Iniciales */}
          <Box
            sx={{
              width: 40,
              height: 40,
              bgcolor: "grey.300",
              borderRadius: "24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mx: 1,
              fontWeight: "bold",
              fontSize: "1rem",
              userSelect: "none",
            }}
          >
            {initials}
          </Box>

          {/* Nombre */}
          <Typography sx={{ fontWeight: "600" }}>{fullName}</Typography>

          {/* Botón de opciones */}
          <IconButton
            onClick={handleClick}
            sx={{
              borderRadius: "50%",
              minWidth: 0,
              width: 30,
              height: 30,
              padding: 0,
              bgcolor: "grey.400",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": {
                bgcolor: "grey.500",
                cursor: "pointer",
              },
            }}
          >
            <MoreHorizIcon fontSize="small" />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={() => handleAsignarPuesto(applicant.id)}>
              Asignar puesto
            </MenuItem>
            <MenuItem onClick={() => handleEditarCandidato(applicant.id)}>
              Editar candidato
            </MenuItem>
          </Menu>
        </Box>

        {/* Info personal */}
        <Box
          sx={{
            mx: 1,
            my: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AlternateEmailIcon height={20} width={20} />
                <Typography sx={{ fontWeight: "bold" }}>Email:</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {applicant.email}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: "right",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LocalPhoneIcon height={20} width={20} />
                <Typography sx={{ fontWeight: "bold" }}>Telefono:</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {applicant.telefono}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LocationOnIcon height={20} width={20} />
                <Typography sx={{ fontWeight: "bold" }}>Provincia:</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {capitalizar(applicant.provincia)}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: "right",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <LocationCityIcon height={20} width={20} />
                <Typography sx={{ fontWeight: "bold" }}>Localidad:</Typography>
              </Box>
              <Typography sx={{ fontSize: "0.875rem" }}>
                {capitalizar(applicant.localidad)}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <WorkOutlineIcon />
                <Typography sx={{ fontWeight: "bold" }}>
                  Puesto de trabajo
                </Typography>
              </Box>
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  fontSize: "0.875rem",
                }}
              >
                {puestoTexto(applicant.id_puesto)}
              </Typography>
            </Box>
          </Box>

          <Typography sx={{ fontWeight: "bold" }}>Sobre mi:</Typography>
          <Box
            sx={{
              bgcolor: "grey.200",
              p: 1,
              borderRadius: 1,
            }}
          >
            <Typography
              component="p"
              sx={{
                fontStyle: "italic",
                display: "inline",
              }}
            >
              {visibleText}
              {shouldTruncate && (
                <Button
                  variant="text"
                  sx={{
                    ml: 1,
                    p: 0,
                    minWidth: 0,
                    fontSize: "0.875rem",
                    textTransform: "none",
                    color: "primary.main",
                    "&:hover": {
                      textDecoration: "underline",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    },
                  }}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "leer menos" : "leer más"}
                </Button>
              )}
            </Typography>
          </Box>
        </Box>

        {/* Footer botones */}
        {applicant.uuid_archivo ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Button
              variant="outlined"
              sx={{
                fontWeight: "600",
                borderColor: "black",
                color: "black",
                "&:hover": {
                  backgroundColor: "grey.200",
                  cursor: "pointer",
                  borderColor: "black",
                },
              }}
              onClick={handleSeeCV}
            >
              Ver CV
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                px: 1,
                border: "1px solid black",
                fontSize: "0.75rem",
                fontWeight: "600",
                borderRadius: "9999px",
                userSelect: "none",
              }}
            >
              No hay CV
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
}
